import React from "react";
import { format } from "date-fns";
import enLocale from "date-fns/locale/en-US";
import deLocale from "date-fns/locale/de";
import { useTranslation } from "react-i18next";

const FormattedDate = ({ date }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === "en" ? enLocale : deLocale;
  return (
    <span>
      {date ? format(new Date(date), "do MMMM yyyy", { locale }) : "-"}
    </span>
  );
};

export default FormattedDate;
